import React, { useCallback, useContext, useRef, useState } from 'react';
import ChatContext from '../../services/ChatContext';
import { Composer, ComposerInputWrap, Textarea, RoundButton, HiddenFile } from './styles';
import { PlusIcon, SendIcon } from './icons';
import { dirFor } from './helpers';

const ACCEPT = 'image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt';

const ComposerV2 = () => {
  const { sendTextMessage, sendMediaMessage, sendingMessage } = useContext(ChatContext);
  const [text, setText] = useState('');
  const fileRef = useRef();
  const taRef = useRef();

  const autoGrow = (el) => {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 140)}px`;
  };

  const handleSend = useCallback(() => {
    const trimmed = text.trim();
    if (!trimmed || sendingMessage) return;
    setText('');
    if (taRef.current) taRef.current.style.height = 'auto';
    sendTextMessage(trimmed);
  }, [text, sendingMessage, sendTextMessage]);

  const onPickFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) sendMediaMessage(file);
    e.target.value = ''; // allow re-selecting the same file
  };

  // Live LTR/RTL — flips as you type Hebrew vs English.
  const dir = dirFor(text);

  return (
    <Composer>
      <RoundButton ghost type="button" onClick={() => fileRef.current?.click()} title="Attach">
        <PlusIcon size={22} />
      </RoundButton>
      <HiddenFile ref={fileRef} type="file" accept={ACCEPT} onChange={onPickFile} />

      <ComposerInputWrap>
        <Textarea
          ref={taRef}
          dir={dir}
          style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}
          value={text}
          rows={1}
          placeholder="Write a message…"
          onChange={(e) => {
            setText(e.target.value);
            autoGrow(e.target);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
        />
      </ComposerInputWrap>

      <RoundButton type="button" onClick={handleSend} disabled={!text.trim() || sendingMessage} title="Send">
        <SendIcon size={20} />
      </RoundButton>
    </Composer>
  );
};

export default ComposerV2;
